export default __webpack_public_path__ + "static/logo-symbol-white-a43d596ea835e85f41775aae0aac93ba.png";